/**
 * AnchorNav — Scrollspy für die Sticky-Anchor-Navigation.
 *
 * Hebt den Link des aktuell sichtbaren Abschnitts hervor (.is-active) und
 * scrollt sanft zum Ziel. Container-frei, nutzt IntersectionObserver.
 *
 * Markup: <nav data-module="AnchorNav"> mit <a data-anchor-link href="#cXX">
 */
export default class AnchorNav {
    constructor(el) {
        this.nav = el;
        this.links = Array.from(el.querySelectorAll('[data-anchor-link]'));
        if (this.links.length === 0) {
            return;
        }

        this.targets = this.links
            .map((link) => {
                const id = (link.getAttribute('href') || '').replace(/^#/, '');
                const target = id ? document.getElementById(id) : null;
                return target ? { link, target } : null;
            })
            .filter(Boolean);

        this.bindSmoothScroll();
        this.bindScrollspy();
    }

    bindSmoothScroll() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        for (const { link, target } of this.targets) {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const top = target.getBoundingClientRect().top + window.scrollY
                    - (this.nav.offsetHeight + 16);
                window.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
            });
        }
    }

    bindScrollspy() {
        if (!('IntersectionObserver' in window)) {
            return;
        }

        const setActive = (link) => {
            for (const { link: l } of this.targets) {
                l.classList.toggle('is-active', l === link);
            }
        };

        const observer = new IntersectionObserver(
            (entries) => {
                const visible = entries
                    .filter((entry) => entry.isIntersecting)
                    .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
                if (visible.length > 0) {
                    const match = this.targets.find((t) => t.target === visible[0].target);
                    if (match) {
                        setActive(match.link);
                    }
                }
            },
            {
                rootMargin: `-${this.nav.offsetHeight + 20}px 0px -60% 0px`,
                threshold: 0,
            }
        );

        for (const { target } of this.targets) {
            observer.observe(target);
        }
    }
}
